module.exports = __webpack_public_path__ + "static/img/报警.d4f04cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/车辆/挖掘机/报警.png
// module id = I6D/
// module chunks = 76